import React from 'react'

const AdminContact = () => {
  return (
    <div>
      cr
    </div>
  )
}

export default AdminContact
